/**
 * Created by shbs on 20/06/2018.
 */
import API from "../api"
import { merge, parseTime } from "../utils"
import store from "../store";
import { getNum, saveFileInfo, uploadFile } from "./upload";
import Big from 'big.js';
import APIS from "../api/fileAxios/fileAxios";
import OSS from 'ali-oss';
import axios from "axios";
export const Partnerada = {
  data () {
    return {
      //  签约流程合同到期时间,可选范围计算函数
      pickerOptions: {
        disabledDate (time) {
          // let startYear = new Date().getFullYear();
          // let endYear = new Date().getFullYear() + 1;
          // console.log(startYear, '获取到时间格式', endYear);
          // return (
          //   time.getTime() < Date.now() - 8.64e7 ||
          //   time.getTime() > new Date(endYear + "-12-31").getTime() ||
          //   time.getTime() < new Date(startYear + "-01-01").getTime()
          // );
          const currentDate = new Date();
          const currentYear = currentDate.getFullYear() + 1;
          // 构建当前年的12月31日的日期对象
          const endOfYear = new Date(currentYear, 11, 31);
          // 比较时间是否在禁用范围内
          return (
            time.getTime() < currentDate.getTime() || // 禁用当前日期之前的时间
            time.getTime() > endOfYear.getTime() || // 禁用当前年的12月31日之后的时间
            (time.getFullYear() === currentYear && time.getMonth() === 11 && time.getDate() === 31) // 禁用当前年的12月31日
          );
        }
      },
      uploadLicenseLoading: false, // 上传营业执照
      uploadAgreementLoading: false, // 上传签约协议
      uploadBusinessPlanLoading: false, // 上传业务规划书
      uploadcooperationPlan: false, // 合作计划书
      isUpLoadSuceess: false, // 文件是否上传成功
      pageloading: false,
      RadForm: {
        companyName: "", // 公司名称
        detailedAddress: "", // 详细地址
        companyWebsite: "", // 公司网站
        nation: "", // 国家地区
        quarterlyTarget: "", // 季度目标
        keyContacts: "", // 关键联系人
        contactEmail: "", // 联系人邮箱
        partnerType: "", // 合作伙伴类型
      },
      Form: {
        urlData: {},
        address: "", // 详细地址
        keyContacts: "", // 关键联系人
        companyWebsite: "", // 公司网站
        certificateLicenseUrl: "", // 营业执照
        businessPlanUrl: "", // 业务规划书
        nation: "", // 国家地区
        companyName: "",
        assignment: "",
        companyMail: "",
        linkManEmail1: "", // 联系人邮箱
        linkManEmail2: "",
        country: "",
        authRegion: "",
        country1: "",
        city: "",
        salesName: "",
        salesUserId: "",
        salesTelephone: "",
        contractValidity: "",
        setUpDate: "",
        peopleNumber: "",
        partnerType: "",
        sponsorType: 0,
        applyReason: "",
        registeredCapital: "",
        parentCompanyName: "",
        parentCompanyCode: "",
        url: "",
        linkMans: [
          {
            generalManagerName: "",
            position: "",
            telephone: "",
            email: "",
            officePhone: "",
            type: "1"
          },
          {
            generalManagerName: "",
            position: "",
            telephone: "",
            email: "",
            officePhone: "",
            type: "3"
          },
          {
            generalManagerName: "",
            position: "",
            telephone: "",
            email: "",
            officePhone: "",
            type: "7"
          },
          {
            generalManagerName: "",
            position: "",
            telephone: "",
            email: "",
            officePhone: "",
            type: "9"
          }
        ],
        salution: null,
        firstName: "",
        lastName: "",
        mobileNumber: "",
        operatorEmail: "",
        businessFocus: "",
        industryFocus: "",
        cooperationPlanUrl: "",
        industryFocusOther: "",
        rebateCoefficient: 0,
        saleTargetQ1: 0,
        saleTargetQ2: 0,
        saleTargetQ3: 0,
        saleTargetQ4: 0,
        reyeeTarget: 0,
        reyeeRebateCoefficient: 0,
        reyeeTargetQ1: 0,
        reyeeTargetQ2: 0,
        reyeeTargetQ3: 0,
        reyeeTargetQ4: 0,
        mainDataSerId: '',
        // 整体考核&分开考核使用提示
        overallAssessmentNote: '1.Overall assessment: Only fill in the annual sales target and no need to subdivide each product series, and the Rebate level is judged according to the annual overall sales target.',
        separateInspectionPrompt: '2.Separate assessment：Enterprise、Reyee 、Home Wi-Fi need to fill in the annual sales target  separately, and the Rebate Level of each product series shall be judged according to their annual sales target.',
        assessmenType: 1, // 整体考核&分开考核切换
        wholeTarget: 0, // 整体考核,填写目标值
        homeRebateCoefficient: 0, // 家用网络,返利系数
        // 家用网络,整体销售目标
        homeTarget: 0,
        homeTargetQ1: 0,
        homeTargetQ2: 0,
        homeTargetQ3: 0,
        homeTargetQ4: 0,
        // 整体考核, 设置目标
        wholeTargetQ1: 0,
        wholeTargetQ2: 0,
        wholeTargetQ3: 0,
        wholeTargetQ4: 0,
      },
      templateId: "",
      selectAuthRegion: [],
      ALLuser: [],
      // 营业执照
      uploadDataLicense: {
        type: "CERTIFICATE_LICENSE"
      },
      // 签约
      uploadData: {
        type: "PARTNER"
      },
      // 业务规划书
      uploadDataPlanning: {
        type: "BUSINESS_PLAN"
      },
      cooperationPlanUploadData: {
        type: "COOPERATION_PLAN"
      },
      AllCountries: [],
      ALLcity: [],
      VADTypeloading: false,
      VADTypelist: [],
      uploadUrl: API.axios.defaults.baseURL + "common/upload",
      citydisable: true,
      ContractTemplateURL:
        window.location.origin + API.axios.defaults.baseURL + "common/templ/",
      DownloadTemplateURL:
        window.location.origin + API.axios.defaults.baseURL + "common/download/",
      accept:
        "image/*,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/x-zip-compressed,application/vnd.ms-excel,application/msword,application/x-rar-compressed,application/x-compress,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,.rar",
      zcAccept: "image/*",
      isUpLoad: false,
      isUpLoadCooperationPlan: false,
      uploadSuccess: false,
      uploadCooperationPlanSuccess: false,
      fileList: [],
      // 合作计划书附件
      cooperationPlanList: [],
      undetermined: [
        {
          companyCode: "undetermined",
          companyName: this.$t("page.VAD.tbc"),
          documentId: "",
          partnerType: "",
          salesName: "",
          salesTelephone: "",
          salesUserId: ""
        }
      ],
      AllBusinessFocus: [
        {
          value: 1,
          title: "switching solution"
        },
        {
          value: 2,
          title: "business wireless solution"
        },
        {
          value: 3,
          title: "surveillance and security solution"
        },
        {
          value: 4,
          title: "structure cabling  and rack solution"
        }
      ],
      AllIndustryFocus: [
        {
          value: 1,
          title: "hospitality"
        },
        {
          value: 2,
          title: "CCTV"
        },
        {
          value: 3,
          title: "ELV"
        },
        {
          value: 4,
          title: "education"
        },
        {
          value: 5,
          title: "government"
        },
        {
          value: 6,
          title: "SMB"
        },
        {
          value: 7,
          title: "others"
        }
      ],
      selectedIndustryFocus: [],
      rebateCoefficientLabel: this.$t("page.VAD.rebateCoefficient"),
      renewal: false,
      companyList: [], //海外主数据平台客户列表
      timer: undefined,
    }
  },
  computed: {
    labelwidth () {
      if (this.$i18n.locale === "en") {
        return "200px";
      }
      return "130px";
    },
    rules () {
      return {
        companyName: [
          {
            required: true,
            message: this.$t("message.needcomName"),
            trigger: "blur"
          }
        ],
        assignment: [
          {
            type: "number",
            required: true,
            message: this.$t("message.needassignment"),
            trigger: "blur"
          }
        ],
        linkManEmail1: [
          {
            required: true,
            message: this.$t("message.needemail"),
            trigger: "blur"
          },
          {
            type: "email",
            message: this.$t("message.needbeemail"),
            trigger: "blur"
          }
        ],
        linkManEmail2: [
          {
            required: true,
            message: this.$t("message.needemail"),
            trigger: "blur"
          },
          {
            type: "email",
            message: this.$t("message.needbeemail"),
            trigger: "blur"
          }
        ],
        companyMail: [
          {
            required: true,
            message: this.$t("message.needCompanyEmail"),
            trigger: "blur"
          },
          {
            type: "email",
            message: this.$t("message.needbeemail"),
            trigger: "blur"
          }
        ],
        country: [
          {
            required: true,
            message: this.$t("message.needecountry"),
            trigger: "change"
          }
        ],
        authRegion: [
          {
            required: true,
            message: this.$t("message.needauthcountry"),
            trigger: "change"
          }
        ],
        city: [
          {
            required: true,
            message: this.$t("message.needecity"),
            trigger: "change"
          }
        ],
        salesName: [
          {
            required: true,
            message: this.$t("message.needesalesName"),
            trigger: "blur"
          }
        ],
        salesTelephone: [
          {
            required: true,
            message: this.$t("message.needesalesphone"),
            trigger: "blur"
          }
        ],
        partnerType: [
          {
            required: true,
            message: this.$t("message.needepartnerType"),
            trigger: "blur"
          }
        ],
        contractValidity: [
          {
            required: true,
            message: this.$t("message.needecontractValidity"),
            trigger: "change"
          }
        ],
        applyReason: [
          {
            required: true,
            message: this.$t("message.needeApplicationReason"),
            trigger: "blur"
          }
        ],
        parentCompanyCode: [
          {
            required: true,
            message: this.$t("message.needeparentCompanyCode"),
            trigger: "blur"
          }
        ],
        //编辑需要
        address: [
          {
            required: true,
            message: this.$t("message.needeaddress"),
            trigger: "blur"
          }
        ],
        peopleNumber: [
          {
            required: true,
            message: this.$t("message.needepeopleNumber"),
            trigger: "blur"
          }
        ],
        setUpDate: [
          {
            required: true,
            message: this.$t("message.needesetUpDate"),
            trigger: "change"
          }
        ],
        registeredCapital: [
          {
            required: true,
            message: this.$t("message.needRegisteredCapital"),
            trigger: "blur"
          }
        ],
        "linkMans[0].generalManagerName": [
          {
            required: true,
            message: this.$t("message.needname"),
            trigger: "blur"
          }
        ],
        "linkMans[0].position": [
          {
            required: true,
            message: this.$t("message.needPosition"),
            trigger: "blur"
          }
        ],
        "linkMans[0].telephone": [
          {
            required: true,
            message: this.$t("message.needMobile"),
            trigger: "blur"
          }
        ],
        "linkMans[0].email": [
          {
            required: true,
            message: this.$t("message.needEmail"),
            trigger: "blur"
          }
        ],

        "linkMans[1].generalManagerName": [
          {
            required: true,
            message: this.$t("message.needname"),
            trigger: "blur"
          }
        ],
        "linkMans[1].position": [
          {
            required: true,
            message: this.$t("message.needPosition"),
            trigger: "blur"
          }
        ],
        "linkMans[1].telephone": [
          {
            required: true,
            message: this.$t("message.needMobile"),
            trigger: "blur"
          }
        ],
        "linkMans[1].email": [
          {
            required: true,
            message: this.$t("message.needEmail"),
            trigger: "blur"
          }
        ],

        "linkMans[2].generalManagerName": [
          {
            required: true,
            message: this.$t("message.needname"),
            trigger: "blur"
          }
        ],
        "linkMans[2].position": [
          {
            required: true,
            message: this.$t("message.needPosition"),
            trigger: "blur"
          }
        ],
        "linkMans[2].telephone": [
          {
            required: true,
            message: this.$t("message.needMobile"),
            trigger: "blur"
          }
        ],
        "linkMans[2].email": [
          {
            required: true,
            message: this.$t("message.needEmail"),
            trigger: "blur"
          }
        ],
        "linkMans[3].generalManagerName": [
          {
            required: true,
            message: this.$t("message.needname"),
            trigger: "blur"
          }
        ],
        "linkMans[3].position": [
          {
            required: true,
            message: this.$t("message.needPosition"),
            trigger: "blur"
          }
        ],
        "linkMans[3].telephone": [
          {
            required: true,
            message: this.$t("message.needMobile"),
            trigger: "blur"
          }
        ],
        "linkMans[3].email": [
          {
            required: true,
            message: this.$t("message.needEmail"),
            trigger: "blur"
          }
        ],
        "url": [
          { required: true, message: this.$t("message.waitUpload"), trigger: 'blur' },
        ],
        salution: [
          {
            required: true,
            message: this.$t("message.needSalution"),
            trigger: "blur"
          }
        ],
        firstName: [
          {
            required: true,
            message: this.$t("message.needFirstName"),
            trigger: "blur"
          }
        ],
        lastName: [
          {
            required: true,
            message: this.$t("message.needLastName"),
            trigger: "blur"
          }
        ],
        mobileNumber: [
          {
            required: true,
            message: this.$t("message.needMobileNumber"),
            trigger: "blur"
          }
        ],
        parentCompanyName: [
          {
            required: true,
            message: this.$t("message.needeparentCompanyCode"),
            trigger: "blur"
          }
        ],
        businessFocus: [
          {
            required: true,
            message: this.$t("message.needBusinessFocus"),
            trigger: "blur"
          }
        ],
        industryFocus: [
          {
            required: true,
            message: this.$t("message.needIndustryFocus"),
            trigger: "blur"
          }
        ],
        /*industryFocusOther: [
          {required: true, message: this.$t("message.needIndustryFocusOther"), trigger: 'blur'},
        ],*/
        industryFocusOther: [
          { validator: this.checkIndustryFocusOther, trigger: "blur" }
        ],
        cooperationPlanUrl: [
          {
            required: this.isCooperationPlanValid,
            message: this.$t("message.needCooperationPlanUrl"),
            trigger: "blur"
          }
        ],
        rebateCoefficient: [
          {
            required: true,
            message: this.$t("message.needRebateCoefficient"),
            trigger: "blur"
          }
        ],
        saleTargetQ1: [
          {
            required: true,
            message: this.$t("message.needSaleTargetQ1"),
            trigger: "blur"
          }
        ],
        saleTargetQ2: [
          {
            required: true,
            message: this.$t("message.needSaleTargetQ1"),
            trigger: "blur"
          }
        ],
        saleTargetQ3: [
          {
            required: true,
            message: this.$t("message.needSaleTargetQ1"),
            trigger: "blur"
          }
        ],
        saleTargetQ4: [
          {
            required: true,
            message: this.$t("message.needSaleTargetQ1"),
            trigger: "blur"
          }
        ],
        reyeeTarget: [
          {
            required: true,
            message: this.$t("message.needassignment"),
            trigger: "blur"
          }
        ],
        reyeeRebateCoefficient: [
          {
            required: true,
            message: this.$t("message.needRebateCoefficient"),
            trigger: "blur"
          }
        ],
        reyeeTargetQ1: [
          {
            required: true,
            message: this.$t("message.needSaleTargetQ1"),
            trigger: "blur"
          }
        ],
        reyeeTargetQ2: [
          {
            required: true,
            message: this.$t("message.needSaleTargetQ1"),
            trigger: "blur"
          }
        ],
        reyeeTargetQ3: [
          {
            required: true,
            message: this.$t("message.needSaleTargetQ1"),
            trigger: "blur"
          }
        ],
        reyeeTargetQ4: [
          {
            required: true,
            message: this.$t("message.needSaleTargetQ1"),
            trigger: "blur"
          }
        ],
        // 家用网络
        wholeTarget: [
          {
            type: "number",
            required: true,
            message: this.$t("message.needassignment"),
            trigger: "blur"
          }
        ],
        homeRebateCoefficient: [
          {
            required: true,
            // message: this.$t("message.needRebateCoefficient"),
            message: '整体考核,必须要填写任务量',
            trigger: "blur"
          }
        ],
        wholeTargetQ1: [
          {
            required: true,
            message: this.$t("message.needSaleTargetQ1"),
            trigger: "blur"
          }
        ],
        wholeTargetQ2: [
          {
            required: true,
            message: this.$t("message.needSaleTargetQ1"),
            trigger: "blur"
          }
        ],
        wholeTargetQ3: [
          {
            required: true,
            message: this.$t("message.needSaleTargetQ1"),
            trigger: "blur"
          }
        ],
        wholeTargetQ4: [
          {
            required: true,
            message: this.$t("message.needSaleTargetQ1"),
            trigger: "blur"
          }
        ]
      };
    }
  },
  methods: {
    init () {
      this.rebateCoefficientLabel =
        this.Form.partnerType === "VAD" || this.Form.partnerType === "vad"
          ? this.$t("page.VAD.rebateCoefficient")
          : this.$t("page.VAD.saleRewardCoefficient");
      this.pageloading = true;
      API.getAllCountries()
        .then(res => {
          let json = res.data;
          if (json.status === "200") {
            this.AllCountries = json.data;
          }
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.pageloading = false;
        })
      API.flowtempl(this.Form.partnerType, this.Form.sponsorType)
        .then(res => {
          let json = res.data;
          if (json.status === "200") {
            this.templateId = json.data.templateId;
          }
        })
        .catch(() => { })
        .finally(() => {
          this.pageloading = false;
        })
      let user = this.$store.state.user;
      if (user) {
        this.ALLuser.push({
          id: 0,
          userName: user.userName,
          userId: user.userId
        });
        this.Form.salesName = user.userName;
        this.Form.salesUserId = user.userId;
      }
      this.remoteVADType("");
      this.getRenewalInfo();
    },
    getRenewalInfo () {
      let id = this.$route.query.documentId;
      let renewal = Boolean(this.$route.query.renewal);
      if (renewal) {
        this.renewal = renewal;
      }
      if (id) {
        API.partnerbaseinfo(id)
          .then(res => {
            let json = res.data;
            if (json.status === "200" && json.data) {
              this.Form = merge({}, this.Form, json.data);
              this.Form.city = Number(json.data.city);
              if (this.Form.authRegion) {
                this.selectAuthRegion = this.Form.authRegion.split(",");
              }
              this.VADTypelist.push({
                documentId: this.Form.parentCompanyCode,
                companyName: this.Form.parentCompanyName
              });
              if (this.Form.partnerType.toUpperCase() !== "ZL") {
                this.getcuntryselect();
              }
              this.Form.contractValidity = new Date().getFullYear() + "-12-31";
              //如果是续签，置空签约目标等数据
              if (this.renewal) {
                this.Form.url = "";
                this.Form.cooperationPlanUrl = "";
                this.Form.companyCode = "";
                // 睿网络
                this.Form.assignment = 0;
                this.Form.rebateCoefficient = 0;
                this.Form.saleTargetQ1 = 0;
                this.Form.saleTargetQ2 = 0;
                this.Form.saleTargetQ3 = 0;
                this.Form.saleTargetQ4 = 0;
                // 易网络
                this.Form.reyeeTarget = 0;
                this.Form.reyeeRebateCoefficient = 0;
                this.Form.reyeeTargetQ1 = 0;
                this.Form.reyeeTargetQ2 = 0;
                this.Form.reyeeTargetQ3 = 0;
                this.Form.reyeeTargetQ4 = 0;
                // 家用网络
                this.Form.homeRebateCoefficient = 0;
                this.Form.homeTarget = 0;
                this.Form.homeTargetQ1 = 0;
                this.Form.homeTargetQ2 = 0;
                this.Form.homeTargetQ3 = 0;
                this.Form.homeTargetQ4 = 0;
              }
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      this.Form.contractValidity = new Date().getFullYear() + "-12-31";
    },
    getcuntryselect () {
      let index;
      if (this.Form.country) {
        this.AllCountries.forEach((item, ind) => {
          if (this.Form.country === item.code) {
            index = ind;
          }
        });
        this.Form.country1 = index;
        if (index) {
          this.initCity(index);
        }
      }
    },
    queruser (query) {
      this.VADTypeloading = true;
      if (query !== "") {
        API.getuserslist({
          params: {
            keyword: query,
            userType: 40
          }
        })
          .then(res => {
            this.VADTypeloading = false;
            let json = res.data;
            if (json.status === "200") {
              this.ALLuser = json.data;
            } else {
            }
          })
          .catch(() => {
            this.VADTypeloading = false;
          });
      }
    },
    querySale (query) {
      this.VADTypeloading = true;
      if (query !== "") {
        API.getSaleOfArea(this.AllCountries[country1].code)
          .then(res => {
            this.VADTypeloading = false;
            let json = res.data;
            if (json.status === "200") {
              this.ALLuser = json.data;
            } else {
            }
          })
          .catch(() => {
            this.VADTypeloading = false;
          });
      }
    },
    initCity (id) {
      this.pageloading = true;
      API.getCityByPartentId(id)
        .then(res => {
          let json = res.data;
          this.pageloading = false;
          if (json.status === "200") {
            this.ALLcity = json.data;
          } else {
          }
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.pageloading = false;
        })
    },
    beforeUpload (file) {
      this.isUpLoad = true;
      this.uploadSuccess = false;
    },
    beforeUploadCooperationPlan (file) {
      this.isUpLoadCooperationPlan = true;
      this.uploadSuccess = false;
    },
    uploadremove (file, fileList) {
      this.Form.url = "";
      this.isUpLoad = false;
      this.uploadSuccess = false;
    },
    removeCertificateLicense (file, fileList) {
      this.Form.certificateLicenseUrl = "";
      this.isUpLoad = false;
      this.uploadSuccess = false;
    },
    removeBusinessPlan (file, fileList) {
      this.Form.businessPlanUrl = "";
      this.isUpLoad = false;
      this.uploadSuccess = false;
    },
    removeCooperationPlan (file, fileList) {
      this.Form.cooperationPlanUrl = "";
      this.isUpLoadCooperationPlan = false;
      this.uploadCooperationPlanSuccess = false;
    },
    // 营业执照上传附件
    async certificateLicenseSuccess ({ file }) {
      if (file.size === 0) {
        this.$notify({
          message: '上传文件大小为0',
          type: 'warning'
        });
        return
      }
      if (file.size > 52428800) {
        this.$notify({
          message: '上传文件大小应在50M以内',
          type: 'warning'
        });
        return
      }
      this.uploadLicenseLoading = true;
      // 保存文件的信息
      let saveFileParams = {};
      const uploadParams = {
        file,
        config: {
          originalFilename: file.name,
          contentType: file.type,
          service: 'customer',
          module: this.uploadDataLicense.type,
          userId: store.state.user.userId,
          privateBucket: true
        },
        onProgress: (p) => {
          this.uploadProgress = Big(getNum(p)).times(100).toFixed(2);
        }
      };
      try {
        const { res, name } = await uploadFile(uploadParams);
        if (res.status === 200) {
          saveFileParams = {
            service: 'customer',
            size: file.size,
            objectName: name,
            module: this.uploadDataLicense.type,
            userId: store.state.user.userId,
            contentType: file.type,
            originalFilename: file.name,
            privateBucket: true
          };
          const { status, data } = await saveFileInfo(saveFileParams);
          if (status === '200') {
            const uploadParam = {
              type: this.uploadDataLicense.type,
              fileId: data.id,
              fileName: data.name,
              downloadUrl: data.path
            }
            API.postOssUpload(uploadParam).then(res => {
              console.log('上传附件信息', res);
              if (res.data.data && Number(res.status) === 200) {
                this.uploadLicenseLoading = false;
                this.isUpLoadSuceess = true;
                this.Form.certificateLicenseUrl = res.data.data;
              }
            })
          }
        }
      } catch (e) {
        console.log(e, '文件上传失败');
        this.isUpLoadSuceess = false
        this.uploadLicenseLoading = true;
      }
    },
    // 签约协议上传附件
    async uploadsuccess ({ file }) {
      if (file.size === 0) {
        this.$notify({
          message: '上传文件大小为0',
          type: 'warning'
        });
        return
      }
      if (file.size > 52428800) {
        this.$notify({
          message: '上传文件大小应在50M以内',
          type: 'warning'
        });
        return
      }
      this.uploadAgreementLoading = true;
      // 保存文件的信息
      let saveFileParams = {};
      const uploadParams = {
        file,
        config: {
          originalFilename: file.name,
          contentType: file.type,
          service: 'customer',
          module: this.uploadData.type,
          userId: store.state.user.userId,
          privateBucket: true
        },
        onProgress: (p) => {
          this.uploadProgress = Big(getNum(p)).times(100).toFixed(2);
        }
      };
      try {
        const { res, name } = await uploadFile(uploadParams);
        if (res.status === 200) {
          saveFileParams = {
            service: 'customer',
            size: file.size,
            objectName: name,
            module: this.uploadData.type,
            userId: store.state.user.userId,
            contentType: file.type,
            originalFilename: file.name,
            privateBucket: true
          };
          const { status, data } = await saveFileInfo(saveFileParams);
          if (status === '200') {
            const uploadParam = {
              type: this.uploadData.type,
              fileId: data.id,
              fileName: data.name,
              downloadUrl: data.path
            }
            API.postOssUpload(uploadParam).then(res => {
              if (res.data.data) {
                this.uploadAgreementLoading = false;
                this.isUpLoadSuceess = true;
                this.Form.url = res.data.data;
              }
            })
          }
        }
      } catch (e) {
        console.log(e);
        this.isUpLoadSuceess = false
        this.uploadAgreementLoading = true;
      }
    },
    // 业务规划书上传附件
    async businessPlanSuccess ({ file }) {
      if (file.size === 0) {
        this.$notify({
          message: '上传文件大小为0',
          type: 'warning'
        });
        return
      }
      if (file.size > 52428800) {
        this.$notify({
          message: '上传文件大小应在50M以内',
          type: 'warning'
        });
        return
      }
      this.uploadBusinessPlanLoading = true;
      // 保存文件的信息
      let saveFileParams = {};
      const uploadParams = {
        file,
        config: {
          originalFilename: file.name,
          contentType: file.type,
          service: 'customer',
          module: this.uploadDataPlanning.type,
          userId: store.state.user.userId,
          privateBucket: true
        },
        onProgress: (p) => {
          this.uploadProgress = Big(getNum(p)).times(100).toFixed(2);
        }
      };
      try {
        const { res, name } = await uploadFile(uploadParams);
        if (res.status === 200) {
          saveFileParams = {
            service: 'customer',
            size: file.size,
            objectName: name,
            module: this.uploadDataPlanning.type,
            userId: store.state.user.userId,
            contentType: file.type,
            originalFilename: file.name,
            privateBucket: true
          };
          const { status, data } = await saveFileInfo(saveFileParams);
          if (status === '200') {
            const uploadParam = {
              type: this.uploadDataPlanning.type,
              fileId: data.id,
              fileName: data.name,
              downloadUrl: data.path
            }
            API.postOssUpload(uploadParam).then(res => {
              if (res.data.data) {
                this.uploadBusinessPlanLoading = false;
                this.isUpLoadSuceess = true
                this.Form.businessPlanUrl = res.data.data;

              }
            })
          }
        }
      } catch (e) {
        console.log(e);
        this.uploadBusinessPlanLoading = true;
        this.isUpLoadSuceess = false
      }
    },

    downloadUpload (id) {
      APIS.getAliOSSDownloadInfo(id).then(async (res) => {
        window.open(res.data.data.fileInfo.url);
      });
    },
    getFileBySing () {
      const params = {
        countryCode: this.Form.country,
        signType: this.Form.partnerType
      }
      API.getFileBySingType(params).then((res) => {
        this.downloadUpload(res.data.data);
      })
    },
    // 上传合作计划书
    async cooperationPlanUploadSuccess ({ file }) {
      if (file.size === 0) {
        this.$notify({
          message: '上传文件大小为0',
          type: 'warning'
        });
        return
      }
      if (file.size > 52428800) {
        this.$notify({
          message: '上传文件大小应在50M以内',
          type: 'warning'
        });
        return
      }
      this.uploadcooperationPlan = true
      // 保存文件的信息
      let saveFileParams = {};
      const uploadParams = {
        file,
        config: {
          originalFilename: file.name,
          contentType: file.type,
          service: 'customer',
          module: this.cooperationPlanUploadData.type,
          userId: store.state.user.userId,
          privateBucket: true
        },
        onProgress: (p) => {
          this.uploadProgress = Big(getNum(p)).times(100).toFixed(2);
        }
      };
      try {
        const { res, name } = await uploadFile(uploadParams);
        if (res.status === 200) {
          saveFileParams = {
            service: 'customer',
            size: file.size,
            objectName: name,
            module: this.cooperationPlanUploadData.type,
            userId: store.state.user.userId,
            contentType: file.type,
            originalFilename: file.name,
            privateBucket: true
          };
          const { status, data } = await saveFileInfo(saveFileParams);
          if (status === '200') {
            const uploadParam = {
              type: this.cooperationPlanUploadData.type,
              fileId: data.id,
              fileName: data.name,
              downloadUrl: data.path
            }
            API.postOssUpload(uploadParam).then(res => {
              if (res.data.data) {
                this.uploadcooperationPlan = false;
                this.isUpLoadSuceess = true;
                this.Form.cooperationPlanUrl = res.data.data;
              }
            })
          }
        }
      } catch (err) {
        console.log('文件上传失败', err);
        this.isUpLoadSuceess = false;
        this.uploadcooperationPlan = true;
      }
    },
    cooperationPlanUploadError (response, file, fileList) {
      this.isUpLoadCooperationPlan = false;
      this.uploadCooperationPlanSuccess = false;
    },
    // 签约特许合作伙伴信息,提交方法
    SubmitAddElitePartnerInformation (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (
            this.Form.partnerType === "TX" ||
            this.Form.partnerType === "ZL"
          ) {
            this.Form.linkManEmail1 = this.Form.companyMail;
          }
          this.pageloading = true;
          let body = {
            linkMans: [],
            partnerBaseInfo: this.Form,
            url: this.Form.url,
            templateId: this.templateId,
            renewal: this.renewal
          };
          API.partnerCreat(body)
            .then(res => {
              this.pageloading = false;
              let json = res.data;
              if (json.status === "200") {
                this.$notify({
                  title: this.$t("message.submitsuccess"),
                  type: "success"
                });
                // this.regist();
                this.$router.push({ name: "ContractInfolist" });
              } else {
              }
            })
            .catch(() => { });
        } else {
          this.$notify({
            message: "Please fill in the required fields",
            type: 'warning'
          })
          return false
        }
      })
    },
    // 签约渠道,提交共用方法
    submitadd (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //  上传文件失败,阻止提交
          if (!this.isUpLoadSuceess || this.uploadcooperationPlan) {
            this.$notify({
              message: this.$t('message.uploadError'),
              type: 'warning'
            })
            return false;
          }
          if (this.Form.partnerType === "VAD" || this.Form.partnerType === "SUB") {
            // VAD分开考核,季度分解目标填写校验
            if (this.Form.assessmenType === 2 || this.Form.assessmenType === 1) {
              // 睿网络季度分解之和
              let saleTargetSum =
                this.Form.saleTargetQ1 +
                this.Form.saleTargetQ2 +
                this.Form.saleTargetQ3 +
                this.Form.saleTargetQ4;
              // 易网络季度分解之和
              let reyeeTargetSum =
                this.Form.reyeeTargetQ1 +
                this.Form.reyeeTargetQ2 +
                this.Form.reyeeTargetQ3 +
                this.Form.reyeeTargetQ4
              // 家用网络季度分解之和
              let homeTargetSum =
                this.Form.homeTargetQ1 +
                this.Form.homeTargetQ2 +
                this.Form.homeTargetQ3 +
                this.Form.homeTargetQ4
              if (saleTargetSum !== this.Form.assignment ||
                reyeeTargetSum !== this.Form.reyeeTarget ||
                homeTargetSum !== this.Form.homeTarget
              ) {
                this.$notify({
                  title: this.$t("page.VAD.quarterlyTasksMustEquals"),
                  type: "error"
                });
                return false;
              }
            } else {
              // VAD整体考核季度分解之和校验
              let targetSum =
                this.Form.wholeTargetQ1 +
                this.Form.wholeTargetQ2 +
                this.Form.wholeTargetQ3 +
                this.Form.wholeTargetQ4;
              if (targetSum !== this.Form.wholeTarget) {
                this.$notify({
                  title: this.$t("page.VAD.quarterlyTasksMustEquals"),
                  type: "error"
                });
                return false;
              }
            }
          }
          if (
            this.Form.partnerType === "TX" ||
            this.Form.partnerType === "ZL"
          ) {
            this.Form.linkManEmail1 = this.Form.companyMail;
          }
          this.pageloading = true;
          let body = {
            linkMans: [],
            partnerBaseInfo: this.Form,
            url: this.Form.url,
            templateId: this.templateId,
            renewal: this.renewal
          };
          API.partnerCreat(body)
            .then(res => {
              this.pageloading = false;
              let json = res.data;
              if (json.status === "200") {
                this.$notify({
                  title: this.$t("message.submitsuccess"),
                  type: "success"
                });
                // this.regist();
                this.$router.push({ name: "ContractInfolist" });
              } else {
              }
            })
            .catch(() => { });
        } else {
          this.$notify({
            message: "Please fill in the required fields",
            type: 'warning'
          })
          return false
        }
      })
    },
    citychange (val) {
      this.citydisable = false;
      this.Form.country = this.AllCountries[val].code;
      this.Form.authRegion = this.Form.country;
      this.selectAuthRegion = [this.Form.authRegion];
      this.Form.city = "";
      this.initCity(this.AllCountries[val].id);
      this.remoteVADType("");
      if (this.Form.country1 === this.Form.country1) {
        this.Form.rebateCoefficient = 0;
        this.Form.reyeeRebateCoefficient = 0;
        this.Form.homeRebateCoefficient = 0;
      } else {
        this.targetChanged();
      }
    },
    authRegionChange (val) {
      this.Form.authRegion = this.selectAuthRegion.join(",");
      console.log(this.Form.authRegion);
    },
    remoteVADType (query) {
      this.VADTypeloading = true;
      let country = this.Form.country ? this.Form.country : "";
      let partnerType = this.Form.partnerType;
      if (partnerType === "ZC" || partnerType === "RZ") {
        API.getVadAndSubs(query, country)
          .then(res => {
            this.VADTypeloading = false;
            let json = res.data;
            if (json.status === "200") {
              this.VADTypelist = json.data;
            }
          })
          .catch(() => {
            this.VADTypeloading = false;
          });
      } else {
        API.getvads(query, country)
          .then(res => {
            this.VADTypeloading = false;
            let json = res.data;
            if (json.status === "200") {
              this.VADTypelist = json.data;
            }
          })
          .catch(() => {
            this.VADTypeloading = false;
          });
      }
    },
    VADChange (val) {
      let index = 0;
      this.VADTypelist.forEach((item, ind) => {
        if (val === item.companyName) {
          index = ind;
        }
      });
      this.Form.parentCompanyCode = this.VADTypelist[index].companyCode;
      this.Form.parentCompanyName = this.VADTypelist[index].companyName;
      if (this.VADTypelist[index].salesUserId) {
        this.Form.salesUserId = this.VADTypelist[index].salesUserId;
      }
      if (this.VADTypelist[index].salesName) {
        this.Form.salesName = this.VADTypelist[index].salesName;
      }
      if (this.VADTypelist[index].salesTelephone) {
        this.Form.salesTelephone = this.VADTypelist[index].salesTelephone;
      }
    },
    salesChange (val) {
      let index = 0;
      this.ALLuser.forEach((item, ind) => {
        if (val === item.userName) {
          index = ind;
        }
      });
      this.Form.salesUserId = this.ALLuser[index].userId;
      this.Form.salesTelephone = this.ALLuser[index].phoneNumber;
    },
    ChangeVADType (val) {
      if (this.$refs.VADType) {
        setTimeout(() => {
          this.Form.parentCompanyName = this.$refs.VADType.selectedLabel;
        }, 100);
      }
    },
    regist () {
      this.Form.companyName = "";
      this.Form.assignment = "";
      this.Form.linkManEmil1 = "";
      this.Form.linkManEmil2 = "";
      this.Form.country = "";
      this.Form.city = "";
      this.Form.salesName = "";
      this.Form.salesTelephone = "";
      this.Form.contractValidity = "";
      this.Form.url = "";
      if (this.$refs["uploadref"]) {
        this.$refs["uploadref"].clearFiles();
      }
    },
    goback () {
      window.history.back();
    },
    checkIndustryFocusOther (rule, value, callback) {
      if (this.selectedIndustryFocus.indexOf(7) < 0) {
        callback();
      } else if (value && value.trim() === "") {
        callback(new Error(this.$t("message.needIndustryFocusOther")));
      } else {
        callback();
      }
    },
    // 切换考核方式,初始化已填写返利系数
    switchRadioChange (val) {
      if (val === 2) {
        this.Form.rebateCoefficient = 0;
        this.Form.reyeeRebateCoefficient = 0;
        this.Form.homeRebateCoefficient = 0;
      }
    },
    // 分开考核-睿网络返利,季度分解任务&返利系数方法
    targetChanged (val) {
      let targetValue = this.Form.assignment ? this.Form.assignment / 1000 : 0;
      //let saleTarget = Number(val / 1000);
      // let saleTarget = val ? val : 0;
      // let targetValue = reyeeTarget + saleTarget;
      if (this.Form.partnerType === "VAD") {
        /**
         * 季度分解任务20%/25%/25%/30%
         */
        this.Form.saleTargetQ1 = (val * 0.2).toFixed(2);
        this.Form.saleTargetQ2 = (val * 0.25).toFixed(2);
        this.Form.saleTargetQ3 = (val * 0.25).toFixed(2);
        this.Form.saleTargetQ4 = (val * 0.3).toFixed(2);
        if (
          this.Form.country1 === null ||
          this.Form.country1 === "" ||
          (this.Form.country1 !== "" && targetValue === 0)
        ) {
          this.Form.rebateCoefficient = 0;
          this.Form.reyeeRebateCoefficient = 0;
          this.Form.homeRebateCoefficient = 0;
        } else {
          // 4000万以上档位的国家 土耳其, 沙特阿拉伯,印度尼西亚, 泰国, 菲律宾, 马来西亚, 越南, 西班牙, 墨西哥
          let areaName = this.AllCountries[this.Form.country1].name;
          if (
            "Türkiye" === areaName ||
            "Saudi Arabia" === areaName ||
            "Indonesia" === areaName ||
            "Thailand" === areaName ||
            "Philippines" === areaName ||
            "Malaysia" === areaName ||
            "Viet Nam" === areaName ||
            "Spain" === areaName ||
            "Mexico" === areaName
          ) {
            if (targetValue && targetValue < 1000) {
              this.Form.rebateCoefficient = 0.025;
            } else if (1000 <= targetValue && targetValue < 1200) {
              this.Form.rebateCoefficient = 0.03;
            } else if (1200 <= targetValue && targetValue < 1400) {
              this.Form.rebateCoefficient = 0.035;
            } else if (1400 <= targetValue && targetValue < 1600) {
              this.Form.rebateCoefficient = 0.04;
            } else if (1600 <= targetValue && targetValue < 2100) {
              this.Form.rebateCoefficient = 0.045;
            } else if (2100 <= targetValue && targetValue < 2700) {
              this.Form.rebateCoefficient = 0.05;
            } else if (targetValue >= 2700) {
              this.Form.rebateCoefficient = 0.06;
            }
            // 2000-4000万档位的国家, 南非, 以色列, 印度, 中国香港,澳大利亚, 意大利, 哥伦比亚,阿拉伯联合酋长国,多米尼加共和国,巴西
          } else if (
            "South Africa" === areaName ||
            "Israel" === areaName ||
            "India" === areaName ||
            "Hong Kong S.A.R" === areaName ||
            "Italy" === areaName ||
            "Colombia" === areaName ||
            "United Arab Emirates" === areaName ||
            "Brazil" === areaName ||
            "Dominican Republic" === areaName
          ) {
            if (targetValue && targetValue < 800) {
              this.Form.rebateCoefficient = 0.025;
            } else if (800 <= targetValue && targetValue < 1000) {
              this.Form.rebateCoefficient = 0.03;
            } else if (1000 <= targetValue && targetValue < 1200) {
              this.Form.rebateCoefficient = 0.035;
            } else if (1200 <= targetValue && targetValue < 1400) {
              this.Form.rebateCoefficient = 0.04;
            } else if (1400 <= targetValue && targetValue < 1600) {
              this.Form.rebateCoefficient = 0.045;
            } else if (1600 <= targetValue && targetValue < 2000) {
              this.Form.rebateCoefficient = 0.05;
            } else if (2000 <= targetValue && targetValue < 2400) {
              this.Form.rebateCoefficient = 0.055;
            } else if (targetValue >= 2400) {
              this.Form.rebateCoefficient = 0.06;
            }
          } else {
            if (targetValue && targetValue < 400) {
              this.Form.rebateCoefficient = 0.025;
            } else if (400 <= targetValue && targetValue < 500) {
              this.Form.rebateCoefficient = 0.03;
            } else if (500 <= targetValue && targetValue < 800) {
              this.Form.rebateCoefficient = 0.035;
            } else if (800 <= targetValue && targetValue < 1200) {
              this.Form.rebateCoefficient = 0.04;
            } else if (1200 <= targetValue && targetValue < 1500) {
              this.Form.rebateCoefficient = 0.045;
            } else if (targetValue >= 1500) {
              this.Form.rebateCoefficient = 0.05;
            }
          }
        }
      } else if (this.Form.partnerType === "SUB") {
        let nonVadTargetValue = this.Form.assignment + this.Form.reyeeTarget + this.Form.homeTarget
        /**
         * 季度分解任务20%/25%/25%/30%
         */
        this.Form.saleTargetQ1 = (val * 0.2).toFixed(2);
        this.Form.saleTargetQ2 = (val * 0.25).toFixed(2);
        this.Form.saleTargetQ3 = (val * 0.25).toFixed(2);
        this.Form.saleTargetQ4 = (val * 0.3).toFixed(2);
        if (nonVadTargetValue && nonVadTargetValue < 2000) {
          this.Form.rebateCoefficient = 1;
          this.Form.reyeeRebateCoefficient = 1;
          this.Form.homeRebateCoefficient = 1;
        } else if (2000 <= nonVadTargetValue && nonVadTargetValue < 5000) {
          this.Form.rebateCoefficient = 1.25;
          this.Form.reyeeRebateCoefficient = 1.25;
          this.Form.homeRebateCoefficient = 1.25;
        } else if (5000 <= nonVadTargetValue && nonVadTargetValue < 10000) {
          this.Form.rebateCoefficient = 1.5;
          this.Form.reyeeRebateCoefficient = 1.5;
          this.Form.homeRebateCoefficient = 1.5;
        } else if (10000 <= nonVadTargetValue && nonVadTargetValue < 20000) {
          this.Form.rebateCoefficient = 1.75;
          this.Form.reyeeRebateCoefficient = 1.75;
          this.Form.homeRebateCoefficient = 1.75;
        } else if (20000 <= nonVadTargetValue && nonVadTargetValue < 30000) {
          this.Form.rebateCoefficient = 2;
          this.Form.reyeeRebateCoefficient = 2;
          this.Form.homeRebateCoefficient = 2;
        } else if (nonVadTargetValue >= 30000) {
          this.Form.rebateCoefficient = 2.25;
          this.Form.reyeeRebateCoefficient = 2.25;
          this.Form.homeRebateCoefficient = 2.25;
        }
      } else if (this.Form.partnerType === 'JP' || this.Form.partnerType === 'YP') {
        let nonVadTargetValue = this.Form.reyeeTarget + this.Form.assignment + this.Form.homeTarget;
        this.Form.saleTargetQ1 = (val * 0.2).toFixed(2);
        this.Form.saleTargetQ2 = (val * 0.25).toFixed(2);
        this.Form.saleTargetQ3 = (val * 0.25).toFixed(2);
        this.Form.saleTargetQ4 = (val * 0.3).toFixed(2);
        if (nonVadTargetValue && nonVadTargetValue < 2000) {
          this.Form.rebateCoefficient = 0.75;
          this.Form.reyeeRebateCoefficient = 0.75;
          this.Form.homeRebateCoefficient = 0.75
        } else if (2000 <= nonVadTargetValue && nonVadTargetValue < 5000) {
          this.Form.rebateCoefficient = 1;
          this.Form.reyeeRebateCoefficient = 1;
          this.Form.homeRebateCoefficient = 1
        } else if (5000 <= nonVadTargetValue && nonVadTargetValue < 10000) {
          this.Form.rebateCoefficient = 1.25;
          this.Form.reyeeRebateCoefficient = 1.25;
          this.Form.homeRebateCoefficient = 1.25
        } else if (10000 <= nonVadTargetValue && nonVadTargetValue < 20000) {
          this.Form.rebateCoefficient = 1.5;
          this.Form.reyeeRebateCoefficient = 1.5;
          this.Form.homeRebateCoefficient = 1.5
        } else if (20000 <= nonVadTargetValue && nonVadTargetValue < 30000) {
          this.Form.rebateCoefficient = 1.75;
          this.Form.reyeeRebateCoefficient = 1.75;
          this.Form.homeRebateCoefficient = 1.75
        } else if (nonVadTargetValue >= 30000) {
          this.Form.rebateCoefficient = 2;
          this.Form.reyeeRebateCoefficient = 2;
          this.Form.homeRebateCoefficient = 2;
        }
      }
    },
    // 分开考核-易网络返利,季度分解任务&返利系数方法
    reyeeTargetChanged (val) {
      let targetValue = this.Form.reyeeTarget ? this.Form.reyeeTarget / 1000 : 0;
      // let reyeeTarget = Number(val / 1000);
      // let targetValue = reyeeTarget + saleTarget;
      if (this.Form.partnerType === "VAD") {
        /**
         * 季度分解任务20%/25%/25%/30%
         */
        this.Form.reyeeTargetQ1 = (val * 0.2).toFixed(2);
        this.Form.reyeeTargetQ2 = (val * 0.25).toFixed(2);
        this.Form.reyeeTargetQ3 = (val * 0.25).toFixed(2);
        this.Form.reyeeTargetQ4 = (val * 0.3).toFixed(2);
        if (this.Form.country1 === null || this.Form.country1 === "") {
          this.Form.rebateCoefficient = 0;
          this.Form.reyeeRebateCoefficient = 0;
          this.Form.homeRebateCoefficient = 0;
        } else {
          let areaName = this.AllCountries[this.Form.country1].name;
          // 4000万以上档位的国家
          if (
            "Türkiye" === areaName ||
            "Saudi Arabia" === areaName ||
            "Indonesia" === areaName ||
            "Thailand" === areaName ||
            "Philippines" === areaName ||
            "Malaysia" === areaName ||
            "Viet Nam" === areaName ||
            "Spain" === areaName ||
            "Mexico" === areaName
          ) {
            if (targetValue && targetValue < 800) {
              this.Form.reyeeRebateCoefficient = 0.02;
            } else if (800 <= targetValue && targetValue < 1000) {
              this.Form.reyeeRebateCoefficient = 0.025;
            } else if (1000 <= targetValue && targetValue < 1300) {
              this.Form.reyeeRebateCoefficient = 0.03;
            } else if (1300 <= targetValue && targetValue < 1500) {
              this.Form.reyeeRebateCoefficient = 0.035;
            } else if (1500 <= targetValue && targetValue < 1900) {
              this.Form.reyeeRebateCoefficient = 0.04;
            } else if (1900 <= targetValue && targetValue < 2500) {
              this.Form.reyeeRebateCoefficient = 0.045;
            } else if (targetValue >= 2500) {
              this.Form.reyeeRebateCoefficient = 0.055;
            }
            // 2000-4000万档位的国家
          } else if (
            "South Africa" === areaName ||
            "Israel" === areaName ||
            "India" === areaName ||
            "Hong Kong S.A.R" === areaName ||
            "Italy" === areaName ||
            "Colombia" === areaName ||
            "United Arab Emirates" === areaName ||
            "Brazil" === areaName ||
            "Dominican Republic" === areaName
          ) {
            if (targetValue && targetValue < 600) {
              this.Form.reyeeRebateCoefficient = 0.02;
            } else if (600 <= targetValue && targetValue < 800) {
              this.Form.reyeeRebateCoefficient = 0.025;
            } else if (800 <= targetValue && targetValue < 1000) {
              this.Form.reyeeRebateCoefficient = 0.03;
            } else if (1000 <= targetValue && targetValue < 1300) {
              this.Form.reyeeRebateCoefficient = 0.035;
            } else if (1300 <= targetValue && targetValue < 1500) {
              this.Form.reyeeRebateCoefficient = 0.04;
            } else if (1500 <= targetValue && targetValue < 1800) {
              this.Form.reyeeRebateCoefficient = 0.045;
            } else if (1800 <= targetValue && targetValue < 2200) {
              this.Form.reyeeRebateCoefficient = 0.05;
            } else if (targetValue >= 2200) {
              this.Form.reyeeRebateCoefficient = 0.055;
            }
            // 20000万以下,非限制国家的计算比例
          } else {
            if (targetValue && targetValue < 300) {
              this.Form.reyeeRebateCoefficient = 0.02;
            } else if (300 <= targetValue && targetValue < 400) {
              this.Form.reyeeRebateCoefficient = 0.025;
            } else if (400 <= targetValue && targetValue < 600) {
              this.Form.reyeeRebateCoefficient = 0.03;
            } else if (600 <= targetValue && targetValue < 1000) {
              this.Form.reyeeRebateCoefficient = 0.035;
            } else if (1000 <= targetValue && targetValue < 1300) {
              this.Form.reyeeRebateCoefficient = 0.04;
            } else if (targetValue >= 1300) {
              this.Form.reyeeRebateCoefficient = 0.045;
            }
          }
        }
      } else if (this.Form.partnerType === "SUB") {
        let nonVadTargetValue = this.Form.reyeeTarget + this.Form.assignment + this.Form.homeTarget
        // let nonVadTargetValue = this.Form.reyeeTarget;
        /**
         * 季度分解任务20%/25%/25%/30%
         */
        this.Form.reyeeTargetQ1 = (val * 0.2).toFixed(2);
        this.Form.reyeeTargetQ2 = (val * 0.25).toFixed(2);
        this.Form.reyeeTargetQ3 = (val * 0.25).toFixed(2);
        this.Form.reyeeTargetQ4 = (val * 0.3).toFixed(2);
        if (nonVadTargetValue && nonVadTargetValue < 2000) {
          this.Form.rebateCoefficient = 1;
          this.Form.reyeeRebateCoefficient = 1;
          this.Form.homeRebateCoefficient = 1;
        } else if (2000 <= nonVadTargetValue && nonVadTargetValue < 5000) {
          this.Form.rebateCoefficient = 1.25;
          this.Form.reyeeRebateCoefficient = 1.25;
          this.Form.homeRebateCoefficient = 1.25;
        } else if (5000 <= nonVadTargetValue && nonVadTargetValue < 10000) {
          this.Form.rebateCoefficient = 1.5;
          this.Form.reyeeRebateCoefficient = 1.5;
          this.Form.homeRebateCoefficient = 1.5;
        } else if (10000 <= nonVadTargetValue && nonVadTargetValue < 20000) {
          this.Form.rebateCoefficient = 1.75;
          this.Form.reyeeRebateCoefficient = 1.75;
          this.Form.homeRebateCoefficient = 1.75;
        } else if (20000 <= nonVadTargetValue && nonVadTargetValue < 30000) {
          this.Form.rebateCoefficient = 2;
          this.Form.reyeeRebateCoefficient = 2;
          this.Form.homeRebateCoefficient = 2;
        } else if (nonVadTargetValue >= 30000) {
          this.Form.rebateCoefficient = 2.25;
          this.Form.reyeeRebateCoefficient = 2.25;
          this.Form.homeRebateCoefficient = 2.25;
        }
      } else if (this.Form.partnerType === 'JP' || this.Form.partnerType === 'YP') {
        let nonVadTargetValue = this.Form.reyeeTarget + this.Form.assignment + this.Form.homeTarget;
        this.Form.reyeeTargetQ1 = (val * 0.2).toFixed(2);
        this.Form.reyeeTargetQ2 = (val * 0.25).toFixed(2);
        this.Form.reyeeTargetQ3 = (val * 0.25).toFixed(2);
        this.Form.reyeeTargetQ4 = (val * 0.3).toFixed(2);
        if (nonVadTargetValue && nonVadTargetValue < 2000) {
          this.Form.reyeeRebateCoefficient = 0.75;
          this.Form.rebateCoefficient = 0.75;
          this.Form.homeRebateCoefficient = 0.75
        } else if (2000 <= nonVadTargetValue && nonVadTargetValue < 5000) {
          this.Form.reyeeRebateCoefficient = 1;
          this.Form.rebateCoefficient = 1;
          this.Form.homeRebateCoefficient = 1
        } else if (5000 <= nonVadTargetValue && nonVadTargetValue < 10000) {
          this.Form.reyeeRebateCoefficient = 1.25;
          this.Form.rebateCoefficient = 1.25;
          this.Form.homeRebateCoefficient = 1.25;
        } else if (10000 <= nonVadTargetValue && nonVadTargetValue < 20000) {
          this.Form.reyeeRebateCoefficient = 1.5;
          this.Form.rebateCoefficient = 1.5;
          this.Form.homeRebateCoefficient = 1.5
        } else if (20000 <= nonVadTargetValue && nonVadTargetValue < 30000) {
          this.Form.reyeeRebateCoefficient = 1.75;
          this.Form.rebateCoefficient = 1.75;
          this.Form.homeRebateCoefficient = 1.75
        } else if (nonVadTargetValue >= 30000) {
          this.Form.reyeeRebateCoefficient = 2;
          this.Form.rebateCoefficient = 2;
          this.Form.homeRebateCoefficient = 2;
        }
      }
    },
    // 分开考核-家用网络返利,季度分解任务&返利系数方法
    homeNetworkTargetChange (val) {
      let targetValue = this.Form.homeTarget ? this.Form.homeTarget / 1000 : 0;
      // let homeTarget = Number(val / 1000);
      // let targetValue = homeTarget + saleTarget;
      if (this.Form.partnerType === "VAD") {
        /**
         * 季度分解任务20%/25%/25%/30%
         */
        this.Form.homeTargetQ1 = (val * 0.2).toFixed(2);
        this.Form.homeTargetQ2 = (val * 0.25).toFixed(2);
        this.Form.homeTargetQ3 = (val * 0.25).toFixed(2);
        this.Form.homeTargetQ4 = (val * 0.3).toFixed(2);

        if (this.Form.country1 === null || this.Form.country1 === "") {
          this.Form.rebateCoefficient = 0;
          this.Form.reyeeRebateCoefficient = 0;
          this.Form.homeRebateCoefficient = 0;
        } else {
          let areaName = this.AllCountries[this.Form.country1].name;
          // 4000万以上档位的国家
          if (
            "Türkiye" === areaName ||
            "Saudi Arabia" === areaName ||
            "Indonesia" === areaName ||
            "Thailand" === areaName ||
            "Philippines" === areaName ||
            "Malaysia" === areaName ||
            "Viet Nam" === areaName ||
            "Spain" === areaName ||
            "Mexico" === areaName
          ) {
            if (targetValue && targetValue < 500) {
              this.Form.homeRebateCoefficient = 0.02;
            } else if (500 <= targetValue && targetValue < 700) {
              this.Form.homeRebateCoefficient = 0.025;
            } else if (700 <= targetValue && targetValue < 800) {
              this.Form.homeRebateCoefficient = 0.03;
            } else if (800 <= targetValue && targetValue < 900) {
              this.Form.homeRebateCoefficient = 0.035;
            } else if (900 <= targetValue && targetValue < 1200) {
              this.Form.homeRebateCoefficient = 0.04;
            } else if (1200 <= targetValue && targetValue < 1600) {
              this.Form.homeRebateCoefficient = 0.045;
            } else if (targetValue >= 1600) {
              this.Form.homeRebateCoefficient = 0.055;
            }
            // 2000-4000万档位的国家
          } else if (
            "South Africa" === areaName ||
            "Israel" === areaName ||
            "India" === areaName ||
            "Hong Kong S.A.R" === areaName ||
            "Italy" === areaName ||
            "Colombia" === areaName ||
            "United Arab Emirates" === areaName ||
            "Brazil" === areaName ||
            "Dominican Republic" === areaName
          ) {
            if (targetValue && targetValue < 300) {
              this.Form.homeRebateCoefficient = 0.02;
            } else if (300 <= targetValue && targetValue < 500) {
              this.Form.homeRebateCoefficient = 0.025;
            } else if (500 <= targetValue && targetValue < 700) {
              this.Form.homeRebateCoefficient = 0.03;
            } else if (700 <= targetValue && targetValue < 800) {
              this.Form.homeRebateCoefficient = 0.035;
            } else if (800 <= targetValue && targetValue < 900) {
              this.Form.homeRebateCoefficient = 0.04;
            } else if (900 <= targetValue && targetValue < 1100) {
              this.Form.homeRebateCoefficient = 0.045;
            } else if (1100 <= targetValue && targetValue < 1300) {
              this.Form.homeRebateCoefficient = 0.05;
            } else if (targetValue >= 1300) {
              this.Form.homeRebateCoefficient = 0.055;
            }
            // 20000万以下,非限制国家的计算比例
          } else {
            if (targetValue && targetValue < 200) {
              this.Form.homeRebateCoefficient = 0.02;
            } else if (200 <= targetValue && targetValue < 300) {
              this.Form.homeRebateCoefficient = 0.025;
            } else if (300 <= targetValue && targetValue < 400) {
              this.Form.homeRebateCoefficient = 0.03;
            } else if (400 <= targetValue && targetValue < 600) {
              this.Form.homeRebateCoefficient = 0.035;
            } else if (600 <= targetValue && targetValue < 800) {
              this.Form.homeRebateCoefficient = 0.04;
            } else if (targetValue >= 800) {
              this.Form.homeRebateCoefficient = 0.045;
            }
          }
        }
      } else if (this.Form.partnerType === 'SUB') {
        let nonVadTargetValue = this.Form.reyeeTarget + this.Form.assignment + this.Form.homeTarget;
        // let nonVadTargetValue = this.Form.homeTarget;
        /**
         * 季度分解任务20%/25%/25%/30%
         */
        this.Form.homeTargetQ1 = (val * 0.2).toFixed(2);
        this.Form.homeTargetQ2 = (val * 0.25).toFixed(2);
        this.Form.homeTargetQ3 = (val * 0.25).toFixed(2);
        this.Form.homeTargetQ4 = (val * 0.3).toFixed(2);
        if (nonVadTargetValue && nonVadTargetValue < 2000) {
          this.Form.rebateCoefficient = 1;
          this.Form.reyeeRebateCoefficient = 1;
          this.Form.homeRebateCoefficient = 1;
        } else if (2000 <= nonVadTargetValue && nonVadTargetValue < 5000) {
          this.Form.rebateCoefficient = 1.25;
          this.Form.reyeeRebateCoefficient = 1.25;
          this.Form.homeRebateCoefficient = 1.25;
        } else if (5000 <= nonVadTargetValue && nonVadTargetValue < 10000) {
          this.Form.rebateCoefficient = 1.5;
          this.Form.reyeeRebateCoefficient = 1.5;
          this.Form.homeRebateCoefficient = 1.5;
        } else if (10000 <= nonVadTargetValue && nonVadTargetValue < 20000) {
          this.Form.rebateCoefficient = 1.75;
          this.Form.reyeeRebateCoefficient = 1.75;
          this.Form.homeRebateCoefficient = 1.75;
        } else if (20000 <= nonVadTargetValue && nonVadTargetValue < 30000) {
          this.Form.rebateCoefficient = 2;
          this.Form.reyeeRebateCoefficient = 2;
          this.Form.homeRebateCoefficient = 2;
        } else if (nonVadTargetValue >= 30000) {
          this.Form.rebateCoefficient = 2.25;
          this.Form.reyeeRebateCoefficient = 2.25;
          this.Form.homeRebateCoefficient = 2.25;
        }
        // 金牌和银牌单独执行系数计算
      } else if (this.Form.partnerType === 'JP' || this.Form.partnerType === 'YP') {
        let nonVadTargetValue = this.Form.reyeeTarget + this.Form.assignment + this.Form.homeTarget;
        this.Form.homeTargetQ1 = (val * 0.2).toFixed(2);
        this.Form.homeTargetQ2 = (val * 0.25).toFixed(2);
        this.Form.homeTargetQ3 = (val * 0.25).toFixed(2);
        this.Form.homeTargetQ4 = (val * 0.3).toFixed(2);
        if (nonVadTargetValue && nonVadTargetValue < 2000) {
          this.Form.rebateCoefficient = 0.75;
          this.Form.reyeeRebateCoefficient = 0.75;
          this.Form.homeRebateCoefficient = 0.75;
        } else if (2000 <= nonVadTargetValue && nonVadTargetValue < 5000) {
          this.Form.rebateCoefficient = 1;
          this.Form.reyeeRebateCoefficient = 1;
          this.Form.homeRebateCoefficient = 1;
        } else if (5000 <= nonVadTargetValue && nonVadTargetValue < 10000) {
          this.Form.rebateCoefficient = 1.25;
          this.Form.reyeeRebateCoefficient = 1.25;
          this.Form.homeRebateCoefficient = 1.25;
        } else if (10000 <= nonVadTargetValue && nonVadTargetValue < 20000) {
          this.Form.rebateCoefficient = 1.5;
          this.Form.reyeeRebateCoefficient = 1.5;
          this.Form.homeRebateCoefficient = 1.5;
        } else if (20000 <= nonVadTargetValue && nonVadTargetValue < 30000) {
          this.Form.rebateCoefficient = 1.75;
          this.Form.reyeeRebateCoefficient = 1.75;
          this.Form.homeRebateCoefficient = 1.75;
        } else if (nonVadTargetValue >= 30000) {
          this.Form.rebateCoefficient = 2;
          this.Form.reyeeRebateCoefficient = 2;
          this.Form.homeRebateCoefficient = 2;
        }
      }
    },
    // 整体考核-返利系数方法
    overallAssessmentTargetChanged (val) {
      let targetValue = this.Form.wholeTarget ? this.Form.wholeTarget / 1000 : 0;
      if (this.Form.partnerType === "VAD") {
        // 1- 睿网络
        /**
         * 季度分解任务20%/25%/25%/30%
         */
        this.Form.assignment = (val / 3).toFixed(2);
        this.Form.reyeeTarget = (val / 3).toFixed(2);
        this.Form.homeTarget = (val / 3).toFixed(2);
        this.Form.saleTargetQ1 = (val * 0.2 / 3).toFixed(2);
        this.Form.saleTargetQ2 = (val * 0.25 / 3).toFixed(2);
        this.Form.saleTargetQ3 = (val * 0.25 / 3).toFixed(2);
        this.Form.saleTargetQ4 = (val * 0.3 / 3).toFixed(2);
        // 2- 易网络
        /**
         * 季度分解任务20%/25%/25%/30%
         */
        this.Form.reyeeTargetQ1 = (val * 0.2 / 3).toFixed(2);
        this.Form.reyeeTargetQ2 = (val * 0.25 / 3).toFixed(2);
        this.Form.reyeeTargetQ3 = (val * 0.25 / 3).toFixed(2);
        this.Form.reyeeTargetQ4 = (val * 0.3 / 3).toFixed(2);
        // 3- 家用网络
        /**
         * 季度分解任务20%/25%/25%/30%
         */
        this.Form.homeTargetQ1 = (val * 0.2 / 3).toFixed(2);
        this.Form.homeTargetQ2 = (val * 0.25 / 3).toFixed(2);
        this.Form.homeTargetQ3 = (val * 0.25 / 3).toFixed(2);
        this.Form.homeTargetQ4 = (val * 0.3 / 3).toFixed(2);
        // 4- 整体考核的季度分解任务
        /**
           * 季度分解任务20%/25%/25%/30%
           */
        // this.Form.wholeTargetQ1 = (val * 0.2).toFixed(2);
        // this.Form.wholeTargetQ2 = (val * 0.25).toFixed(2);
        // this.Form.wholeTargetQ3 = (val * 0.25).toFixed(2);
        // this.Form.wholeTargetQ4 = (val * 0.3).toFixed(2);

        if (this.Form.country1 === null || this.Form.country1 === "" || this.Form.country1 !== this.Form.country1) {
          this.Form.rebateCoefficient = 0;
          this.Form.reyeeRebateCoefficient = 0;
          this.Form.homeRebateCoefficient = 0;
        } else {
          let areaName = this.AllCountries[this.Form.country1].name;
          // 4000万以上档位的国家
          if (
            "Türkiye" === areaName ||
            "Saudi Arabia" === areaName ||
            "Indonesia" === areaName ||
            "Thailand" === areaName ||
            "Philippines" === areaName ||
            "Malaysia" === areaName ||
            "Viet Nam" === areaName ||
            "Spain" === areaName ||
            "Mexico" === areaName
          ) {
            if (targetValue && targetValue < 2000) {
              this.Form.rebateCoefficient = 0.025;
              this.Form.reyeeRebateCoefficient = 0.02;
              this.Form.homeRebateCoefficient = 0.02;
            } else if (2000 <= targetValue && targetValue < 2500) {
              this.Form.rebateCoefficient = 0.03;
              this.Form.reyeeRebateCoefficient = 0.025;
              this.Form.homeRebateCoefficient = 0.025;
            } else if (2500 <= targetValue && targetValue < 3000) {
              this.Form.rebateCoefficient = 0.035;
              this.Form.reyeeRebateCoefficient = 0.03;
              this.Form.homeRebateCoefficient = 0.03;
            } else if (3000 <= targetValue && targetValue < 3500) {
              this.Form.rebateCoefficient = 0.04;
              this.Form.reyeeRebateCoefficient = 0.035;
              this.Form.homeRebateCoefficient = 0.035;
            } else if (3500 <= targetValue && targetValue < 4500) {
              this.Form.rebateCoefficient = 0.045;
              this.Form.reyeeRebateCoefficient = 0.04;
              this.Form.homeRebateCoefficient = 0.04;
            } else if (4500 <= targetValue && targetValue < 6000) {
              this.Form.rebateCoefficient = 0.05;
              this.Form.reyeeRebateCoefficient = 0.045;
              this.Form.homeRebateCoefficient = 0.045;
            } else if (targetValue >= 6000) {
              this.Form.rebateCoefficient = 0.06;
              this.Form.reyeeRebateCoefficient = 0.055;
              this.Form.homeRebateCoefficient = 0.055;
            }
            // 2000-4000万档位的国家
          } else if (
            "South Africa" === areaName ||
            "Israel" === areaName ||
            "India" === areaName ||
            "Hong Kong S.A.R" === areaName ||
            "Italy" === areaName ||
            "Colombia" === areaName ||
            "United Arab Emirates" === areaName ||
            "Brazil" === areaName ||
            "Dominican Republic" === areaName
          ) {
            if (targetValue && targetValue < 1500) {
              this.Form.rebateCoefficient = 0.025;
              this.Form.reyeeRebateCoefficient = 0.02;
              this.Form.homeRebateCoefficient = 0.02;
            } else if (1500 <= targetValue && targetValue < 2000) {
              this.Form.rebateCoefficient = 0.03;
              this.Form.reyeeRebateCoefficient = 0.025;
              this.Form.homeRebateCoefficient = 0.025;
            } else if (2000 <= targetValue && targetValue < 2500) {
              this.Form.rebateCoefficient = 0.035;
              this.Form.reyeeRebateCoefficient = 0.03;
              this.Form.homeRebateCoefficient = 0.03;
            } else if (2500 <= targetValue && targetValue < 3000) {
              this.Form.rebateCoefficient = 0.04;
              this.Form.reyeeRebateCoefficient = 0.035;
              this.Form.homeRebateCoefficient = 0.035;
            } else if (3000 <= targetValue && targetValue < 3500) {
              this.Form.rebateCoefficient = 0.045;
              this.Form.reyeeRebateCoefficient = 0.04;
              this.Form.homeRebateCoefficient = 0.04;
            } else if (3500 <= targetValue && targetValue < 4000) {
              this.Form.rebateCoefficient = 0.05;
              this.Form.reyeeRebateCoefficient = 0.045;
              this.Form.homeRebateCoefficient = 0.045;
            } else if (4000 <= targetValue && targetValue < 5000) {
              this.Form.rebateCoefficient = 0.055;
              this.Form.reyeeRebateCoefficient = 0.05;
              this.Form.homeRebateCoefficient = 0.05;
            } else if (targetValue >= 5000) {
              this.Form.rebateCoefficient = 0.06;
              this.Form.reyeeRebateCoefficient = 0.055;
              this.Form.homeRebateCoefficient = 0.055;
            }
            // 20000万以下,非限制国家的计算比例
          } else {
            if (targetValue && targetValue < 700) {
              this.Form.rebateCoefficient = 0.025;
              this.Form.reyeeRebateCoefficient = 0.02;
              this.Form.homeRebateCoefficient = 0.02;
            } else if (700 <= targetValue && targetValue < 1000) {
              this.Form.rebateCoefficient = 0.03;
              this.Form.reyeeRebateCoefficient = 0.025;
              this.Form.homeRebateCoefficient = 0.025;
            } else if (1000 <= targetValue && targetValue < 1500) {
              this.Form.rebateCoefficient = 0.035;
              this.Form.reyeeRebateCoefficient = 0.03;
              this.Form.homeRebateCoefficient = 0.03;
            } else if (1500 <= targetValue && targetValue < 2300) {
              this.Form.rebateCoefficient = 0.04;
              this.Form.reyeeRebateCoefficient = 0.035;
              this.Form.homeRebateCoefficient = 0.035;
            } else if (2300 <= targetValue && targetValue < 3000) {
              this.Form.rebateCoefficient = 0.045;
              this.Form.reyeeRebateCoefficient = 0.04;
              this.Form.homeRebateCoefficient = 0.04;
            } else if (targetValue >= 3000) {
              this.Form.rebateCoefficient = 0.05;
              this.Form.reyeeRebateCoefficient = 0.045;
              this.Form.homeRebateCoefficient = 0.045;
            }
          }
        }
      }
    },
    // 整体考核-季度分解任务
    overallAssessmentTargetQuarter (val) {
      // 1- 睿网络
      /**
       * 季度分解任务20%/25%/25%/30%
       */
      this.Form.saleTargetQ1 = (val * 0.2).toFixed(2);
      this.Form.saleTargetQ2 = (val * 0.25).toFixed(2);
      this.Form.saleTargetQ3 = (val * 0.25).toFixed(2);
      this.Form.saleTargetQ4 = (val * 0.3).toFixed(2);
      // 2- 易网络
      /**
       * 季度分解任务20%/25%/25%/30%
       */
      this.Form.reyeeTargetQ1 = (val * 0.2).toFixed(2);
      this.Form.reyeeTargetQ2 = (val * 0.25).toFixed(2);
      this.Form.reyeeTargetQ3 = (val * 0.25).toFixed(2);
      this.Form.reyeeTargetQ4 = (val * 0.3).toFixed(2);
      // 3- 家用网络
      /**
       * 季度分解任务20%/25%/25%/30%
       */
      this.Form.homeTargetQ1 = (val * 0.2).toFixed(2);
      this.Form.homeTargetQ2 = (val * 0.25).toFixed(2);
      this.Form.homeTargetQ3 = (val * 0.25).toFixed(2);
      this.Form.homeTargetQ4 = (val * 0.3).toFixed(2);

    },
    // 整体考核-季度分解任务
    overallAssessmentTargetQuarterOne (val) {
      // 1- 睿网络
      /**
       * 季度分解任务20%/25%/25%/30%
       */
      console.log(val);
      this.Form.saleTargetQ1 = (val * 0.2).toFixed(2);
      this.Form.saleTargetQ2 = (val * 0.25).toFixed(2);
      this.Form.saleTargetQ3 = (val * 0.25).toFixed(2);
      this.Form.saleTargetQ4 = (val * 0.3).toFixed(2);
    },
    overallAssessmentTargetQuarterTwo (val) {

      // 2- 易网络
      /**
       * 季度分解任务20%/25%/25%/30%
       */
      this.Form.reyeeTargetQ1 = (val * 0.2).toFixed(2);
      this.Form.reyeeTargetQ2 = (val * 0.25).toFixed(2);
      this.Form.reyeeTargetQ3 = (val * 0.25).toFixed(2);
      this.Form.reyeeTargetQ4 = (val * 0.3).toFixed(2);
    },
    overallAssessmentTargetQuarterThree (val) {
      // 3- 家用网络
      /**
       * 季度分解任务20%/25%/25%/30%
       */
      this.Form.homeTargetQ1 = (val * 0.2).toFixed(2);
      this.Form.homeTargetQ2 = (val * 0.25).toFixed(2);
      this.Form.homeTargetQ3 = (val * 0.25).toFixed(2);
      this.Form.homeTargetQ4 = (val * 0.3).toFixed(2);

    },
    companyNameSelectChanged (val) {
      this.Form.companyName = val.customerName;
      this.Form.mainDataSerId = val.customerOnlyCode;
      this.$forceUpdate();
    },
    selectBlur (e) {
      if (e.target.value !== '') {
        this.Form.companyName = e.target.value;
        this.$forceUpdate();   // 强制更新
      }
    },
    selectClear () {
      this.Form.companyName = '';
      this.Form.mainDataSerId = '';
      this.$forceUpdate();
    },
    searchCompany (val) {
      this.Form.mainDataSerId = val.customerOnlyCode;
      this.$forceUpdate();
      clearTimeout(this.timer);
      this.timer = setTimeout(async () => {
        if (val) {
          let that = this;
          API.searchCustomer({ params: { keyword: val } }).then(res => {
            let json = res.data;
            if (json.data.length < 1) {
              that.companyList = [];
              // 填写的渠道名称主数据接口没有返回，表示新增加的渠道
              that.Form.companyName = val;
              that.Form.mainDataSerId = '';
              that.$forceUpdate();
            } else {
              that.companyList = json.data;
            }
          }).catch(e => {
            console.error(e);
          });
        }
      }, 100);
    }
  }
};

export const formate = {
  methods: {
    parseTime (time, fromat) {
      return parseTime(time, fromat);
    },
    getApprovalstate (key) {
      let map = {
        "1": this.$t("Approvalstate['1']"),
        "-1": this.$t("Approvalstate['-1']"),
        "0": this.$t("Approvalstate['0']")
      };
      return map[key];
    },
    getNodeStateName (index, nodeList) {
      try {
        if (nodeList.length) {
          return nodeList[index - 1].stepName;
        }
      } catch (e) { }
    },
    getUTCtime (row) {
      if (row) {
        let sysDate = new Date(row);
        let offset = sysDate.getTimezoneOffset() * 1000 * 60;
        let loacltime = sysDate.getTime() - offset;
        return parseTime(loacltime, "{y}-{m}-{d}");
      }
      return "";
    },
    /**
     * @return {string}
     */
    MoneyFormat (money) {
      if (money) {
        money = String(money);
        let left = money.split(".")[0],
          right = money.split(".")[1];
        right = right
          ? right.length >= 2
            ? "." + right.substr(0, 2)
            : "." + right + "0"
          : ".00";
        let temp = left
          .split("")
          .reverse()
          .join("")
          .match(/(\d{1,3})/g);
        return (
          (Number(money) < 0 ? "-" : "") +
          temp
            .join(",")
            .split("")
            .reverse()
            .join("") +
          right
        );
      } else if (money === 0) {
        // 注意===在这里的使用，如果传入的money为0,if中会将其判定为boolean类型，故而要另外做===判断
        return "0.00";
      } else {
        return "";
      }
    },
    renderheader (h, { column, $index }) {
      return h("span", {}, [
        h("span", {}, column.label.split("/")[0]),
        h("br"),
        h("span", {}, column.label.split("/")[1])
      ]);
    },
    fullHeader (h, { column }) {
      if (column.label) {
        return h(
          "el-tooltip",
          {
            attrs: {
              class: "item",
              effect: "dark",
              content: column.label,
              placement: "bottom"
            }
          },
          [h("span", [column.label])]
        );
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/utils/mixin.js